import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { Observable, of } from 'rxjs';
// import { DASHBOARD_ROUTE } from 'app/admin/dashboard/dashboard.routes';
// import { DOCTOR_ROUTE } from 'app/doctor/doctor.routes';
// import { PATIENT_ROUTE } from 'app/patient/patient.routes';
// import { EXTRA_PAGES_ROUTE } from 'app/extra-pages/extra-pages.routes';
// import { MULTILEVEL_ROUTE } from 'app/multilevel/multilevel.routes';
// import { SECONDLEVEL_ROUTE } from 'app/multilevel/secondlevel/secondlevel.routes';
// import { THIRDLEVEL_ROUTE } from 'app/multilevel/thirdlevel/thirdlevel.routes';
import { RouteInfo } from './sidebar.metadata';
import { CLIENT_ROUTE } from 'app/organization/client.routes';
import { ATTENDANCE_ROUTE } from 'app/attendances/attendance.routes';
import { DEVICE_ROUTE } from 'app/devices/device.routes';
import { AI_ROUTE } from 'app/ai/ai.routes';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  getRouteInfo(): Observable<RouteInfo[]> {
    return of(this.buildSidebarRoutes());
  }

  private buildSidebarRoutes(): RouteInfo[] {
    return [
      this.createLeafItem(this.requireRoute(AI_ROUTE, ''), '/ai'),

      //Grupos Cliente
      this.createParentItem('MENUITEMS.ORGANIZATION.TEXT', 'business', [
        this.createLeafItem(this.requireRoute(CLIENT_ROUTE, 'companies-records'), '/organization'),
        this.createLeafItem(this.requireRoute(CLIENT_ROUTE, 'org-units'), '/organization'),
        this.createLeafItem(this.requireRoute(CLIENT_ROUTE, 'employees'), '/organization'),
      ]),

      this.createParentItem('MENUITEMS.JOURNEYS.TEXT', 'calendar_month', [
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'journeys'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'daily-schedules'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'work-cycles'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'rest-configurations'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'work-calendar'), '/attendance'),
      ]),

      this.createParentItem('MENUITEMS.DEVICES.TEXT', 'devices', [
        this.createLeafItem(this.requireRoute(DEVICE_ROUTE, ''), '/devices'),
        this.createLeafItem(this.requireRoute(DEVICE_ROUTE, 'commands'), '/devices'),
        this.createLeafItem(this.requireRoute(DEVICE_ROUTE, 'enrollments'), '/devices'),
      ]),

      this.createParentItem('MENUITEMS.TRACKING.TEXT', 'location_on', [
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'tracking-points'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'zones'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'work-centers'), '/attendance'),
      ]),

      // Operación diaria de asistencia. Cada hoja conserva el auth definido
      // en ATTENDANCE_ROUTE; estos grupos solo reorganizan la navegación.
      this.createParentItem('MENUITEMS.ATTENDANCE.TEXT', 'support_agent', [
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'punch'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'attendance-events'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'facial-evidences'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'attendance-attempts'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'attendance-results'), '/attendance'),
      ]),

      this.createParentItem('MENUITEMS.INCIDENTS.TEXT', 'assignment_late', [
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'absences'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'delays'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'early-exits'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'missing-punches'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'attendance-justifications'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'overtimes'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'attendance-justification-types'), '/attendance'),
      ]),

      this.createParentItem('MENUITEMS.AUDIT.TEXT', 'policy', [
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'mobile-logs'), '/attendance'),
        this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'system-logs'), '/attendance'),
      ]),
      // this.createLeafItem(this.requireRoute(ATTENDANCE_ROUTE, 'journey'), '/attendance'),
      // this.createGroupTitle('MENUITEMS.MAIN.TEXT'),
      // this.createParentItem('MENUITEMS.DASHBOARD.TEXT', 'space_dashboard', [
      //   this.createLeafItem(this.requireRoute(DASHBOARD_ROUTE, 'main'), '/dashboard'),
      //   this.createLeafItem(this.requireRoute(DASHBOARD_ROUTE, 'dashboard2'), '/dashboard'),
      // ]),





      // this.createLeafItem(this.requireRoute(DOCTOR_ROUTE, 'dashboard'), '/doctor'),
      // this.createLeafItem(this.requireRoute(PATIENT_ROUTE, 'dashboard'), '/patient'),

      // this.createParentItem('Extra Pages', 'description', [
      //   this.createLeafItem(this.requireRoute(EXTRA_PAGES_ROUTE, 'blank'), '/extra-pages'),
      // ]),
      // this.createParentItem('Multi level Menu', 'slideshow', [
      //   this.createLeafItem(this.requireRoute(MULTILEVEL_ROUTE, 'first1'), '/multilevel'),
      //   this.createParentItem('Second', '', [
      //     this.createLeafItem(this.requireRoute(SECONDLEVEL_ROUTE, 'second1'), '/multilevel/secondlevel'),
      //     this.createParentItem('Second 2', '', [
      //       this.createLeafItem(this.requireRoute(THIRDLEVEL_ROUTE, 'third1'), '/multilevel/thirdlevel'),
      //     ], 'ml-sub-menu2'),
      //   ], 'ml-sub-menu'),
      //   this.createLeafItem(this.requireRoute(MULTILEVEL_ROUTE, 'first3'), '/multilevel'),
      // ]),
    ];
  }

  private createGroupTitle(title: string): RouteInfo {
    return { path: '', title, iconType: '', icon: '', class: '', groupTitle: true, badge: '', badgeClass: '', role: [], submenu: [] };
  }

  private createParentItem(title: string, icon: string, submenu: RouteInfo[], className = 'menu-toggle'): RouteInfo {
    return { path: '', title, iconType: icon ? 'material-icons-outlined' : '', icon, class: className, groupTitle: false, badge: '', badgeClass: '', role: [], submenu };
  }

  private createLeafItem(route: Route, prefix: string): RouteInfo {
    const nav = route.data?.['nav'];
    return { path: this.joinPaths(prefix, route.path || ''), title: nav?.title || route.path || '', iconType: nav?.icon ? 'material-icons-outlined' : '', icon: nav?.icon || '', class: nav?.icon ? '' : (nav?.className || 'ml-menu'), groupTitle: !!nav?.groupTitle, badge: '', badgeClass: '', role: [], auth: route.data?.['auth'], nav, submenu: [] };
  }

  private requireRoute(routes: Route[], path: string): Route {
    const route = routes.find((item) => item.path === path);
    if (!route) {
      throw new Error(`Sidebar route not found for path: ${path}`);
    }
    return route;
  }

  private joinPaths(prefix: string, path: string): string {
    const normalizedPrefix = prefix.startsWith('/') ? prefix : `/${prefix}`;
    return `${normalizedPrefix}/${path}`.replace(/\/+/g, '/');
  }
}
